import { Component } from '@angular/core';
import {Router, RouterLink, RouterLinkActive, NavigationEnd} from "@angular/router";
import {BillingService} from "../../../services/billing.service";
import {FormsModule} from '@angular/forms';
import {NgClass} from "@angular/common";

@Component({
  selector: 'app-account-tabs',
  standalone: true,
  imports: [
    RouterLink,
    RouterLinkActive,
    FormsModule,
    NgClass
  ],
  templateUrl: './account-tabs.component.html',
  styleUrl: './account-tabs.component.scss'
})
export class AccountTabsComponent {

  selectedTab: string;

  constructor(
    private router: Router,
    private billingService: BillingService
  ) {}

  ngOnInit() {
    // Set the selectedTab based on the current URL
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.selectedTab = this.router.url;
      }
    });

    // Initialize the selected tab correctly
    this.selectedTab = this.router.url;
  }

  onTabChange(event: Event) {
    const element = event.target as HTMLSelectElement;
    const selectedValue = element.value;

    if (selectedValue === 'manage-subscription') {
      this.openBillingPortal();
    } else {
      this.selectedTab = selectedValue;
      this.router.navigate([this.selectedTab]);
    }
  }

  openBillingPortal() {
    this.billingService.openBillingPortal();
  }

}
